/**
 * Unsplash trail / road running atmosphere for Running app landing.
 * Keep URLs stable; swap only if assets move.
 */
export const RUNNING_LANDING_IMAGES = {
  trailBackground:
    'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=1600&q=80',
  packBackground:
    'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=1600&q=80',
};
